/**
 * Authentication hooks wrapper for Clerk.
 *
 * Provides convenient access to authentication state and user information.
 */
import { useAuth as useClerkAuth, useUser as useClerkUser } from '@clerk/clerk-react'

/**
 * Hook to access authentication state.
 *
 * @returns Authentication state including isSignedIn, isLoaded, and userId
 */
export const useAuth = () => {
  const { isSignedIn, isLoaded, userId, getToken } = useClerkAuth()

  return {
    isSignedIn,
    isLoaded,
    userId,
    getToken,
  }
}

/**
 * Hook to access current user information.
 *
 * @returns User object with profile information
 */
export const useUser = () => {
  const { user, isLoaded } = useClerkUser()

  return {
    user,
    isLoaded,
  }
}
